
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.578 5.252c1.297-.082 2.072.35 2.922 1.24.43.449.912.724.912.724l1.996 1.186c.352.21.469.665.26 1.018a.747.747 0 01-.962.29l-2.068-.998a27.359 27.359 0 01-.645 1.932l1.228 1.771.047.067c.13.186.185.403.173.614l-.223 3.99a.951.951 0 01-1.002.896.953.953 0 01-.896-.93l-.077-3.576-1.266-1.575-.505 1.665-.025.083a1.027 1.027 0 01-.697.685l-3.54 1.004a.95.95 0 01-1.174-.656.956.956 0 01.58-1.15l2.843-1.07.44-1.959c.02-.092.864-3.339.864-3.339l-.883.078-.435 2.006a.69.69 0 01-1.365-.182l.144-2.797a.82.82 0 01.64-.757l.13-.028zm3.855-3.224c.412.05.663.098 1.176.226a.361.361 0 01.242.2l.018.06.041.657a.39.39 0 00.247.341l.074.022.76.143a.29.29 0 01.238.273l-.005.067-.017.09a.29.29 0 01-.273.237l-.067-.005-1.044-.197c-.012.887-.696 1.667-1.6 1.703-.605.023-1.005-.05-1.274-.2a1.903 1.903 0 01.568-3.634l.029-.002.03-.003.019-.002h.006c.264-.024.552-.01.832.024z"}})])
          )
        }
      }
    